module.exports = __webpack_public_path__ + "img/approve-list20.9892ccb4.png";